import { createTheme } from "@mui/material/styles"

const theme = createTheme({
  typography: {
    fontFamily: ["Manrope", "Arial"],
  },
})

export default theme
